<template>
    <div>
        <h3 style="text-align: center">เพิ่มบัญชีธนาคาร</h3>
        <div class="form-group row">
            <div class="col-4 text-right">รายการ</div>
            <div class="col-6">
                <input class="form-control" v-model="form.name"/>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-4 text-right">ชื่อบัญชี</div>
            <div class="col-6">
                <input class="form-control" v-model="form.account_name"/>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-4 text-right">เลขที่บัญชี</div>
            <div class="col-6">
                <input class="form-control" v-model="form.account_number"/>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-4 text-right">ธนาคาร</div>
            <div class="col-6">
                <b-form-select :options="optionBankType" v-model="form.bank_type_id">
                </b-form-select>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-4 text-right">สาขา</div>
            <div class="col-6">
                <input class="form-control" v-model="form.bank_branch"/>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-4 text-right">ชื่อเจ้าของบัญชี</div>
            <div class="col-6">
                <input class="form-control" v-model="form.account_holder"/>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-4 text-right">เบอร์โทรศัพท์</div>
            <div class="col-6">
                <input class="form-control" v-model="form.phone"/>
            </div>
        </div>
        <div class="col text-center">
            <button class="btn btn-success" @click="submitData">
                <icon name="save" style="width: 25px"></icon>
                บันทึก
            </button> &nbsp;&nbsp;
            <button class="btn btn-outline-secondary" @click="cancelData">
                <icon name="times" style="width: 25px"></icon>
                ยกเลิก
            </button>
        </div>
        <!--<pre class="alert-warning">{{optionBankType}}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";
    export default {
        name: "bank-data-modal",
        created(){
            this.$store.dispatch("Common/getBankType");
        },
        computed:{
            ...mapState({
                form : state=>{
                    return state.Bank.form;
                },
                optionBankType : state=>{
                    return [
                        {
                            value: null,
                            text: "เลือกธนาคาร"
                        },
                        ...state.Common.bank_type.map(type => ({
                            value: type.id,
                            text: type.name
                        }))
                    ];
                }
            })
        },
        methods:{
            submitData(){
                this.$emit("submit",this.form);
            },
            cancelData(){
                this.$emit("submit",0);
            }
        }
    }
</script>

<style scoped>

</style>
